import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import router from "./router.js";
import Print from './plugins/print.js'


// import qs from 'qs'
Vue.prototype.axios = axios;
Vue.use(VueAxios, axios);
Vue.use(ElementUI);
// Vue.config.productionTip = false
Vue.use(Print) // 注册

new Vue({
  el: '#app',
  router,  // 注入到根实例中
  render: h => h(App)
})
// new Vue({
//   render: h => h(App),

// }).$mount('#app')
